import { handleError } from "@network/handle-errors";
import { http } from "@network/http";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "noval";
import { useState } from "react";

const handleWebsite = (website) => {
  const isProtocol =
    website?.startsWith("https") || website?.startsWith("http");
  return isProtocol ? website : `https://${website}`;
};

export const usePartnerSubmitHandler = () => {
  const router = useRouter();
  const { lang } = useTranslation();
  const { dispatch } = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const authed = useSelector("authed");
  const isAppQuery = useSelector("opportunities.isApp") === "true";
  const activeTab = useSelector(
    "opportunities.activeTab",
    +router.query.tab || 1
  );

  const submitHandler = async (values, type, formContext, filesName) => {
    const { getValues, setError } = formContext;
    setIsLoading(true);
    const formData = new FormData();
    values = {
      ...values,
      ...(type === 2
        ? {
          phone_number: +getValues("phone_number"),
          website: handleWebsite(values?.website),
        }
        : {}),
      type,
    };

    Object.keys(values).forEach((key) => {
      if (filesName.includes(key)) {
        values?.[key].forEach((el) => {
          if (el.file instanceof File) {
            formData.append(`${key}[${el.id}]`, el.file);
          }
        });
      } else formData.append(key, values?.[key]);
    });

    try {
      await http.post("/real-estate-create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setIsLoading(false);

      if (isAppQuery) {
        window.location.href = `${window.location.origin}/${lang}${router.pathname}?app=true&tab=${activeTab}&status=1`;
      } else {
        if (authed) router.push("/home");
        else router.push("/");
        dispatch({
          isOpen: true, type: "submit_opportunities"
        }, "modals.successModal");
      }
    } catch (error) {
      setIsLoading(false);
      if (isAppQuery) {
        window.location.href = `${window.location.origin}/${lang}${router.pathname}?app=true&tab=${activeTab}&status=1`;
      }
      handleError(error, { setError });
    }
  };

  return { submitHandler, isLoading };
};
